













































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';

@Component
export default class EntityModalTab extends Vue {
  @Prop({ default: () => false }) loading!: boolean;
  @PropSync('promptToSave', { default: () => false })
  promptToSaveSync!: boolean;

  onSubmit() {
    this.$emit('submit');
  }
}
